<template>
  <div v-if="project !== null" class="project-detail">
    <p><b>{{ project.title }}</b></p>
    <p>Project ID {{ id }}</p>
    <p>{{ project.recipient }}</p>
    <p id="project-message">{{ project.message }}</p>
    <p>{{ project.created }}</p>
  </div>
</template>

<script>
import axios from 'axios'
import authService from '../auth'
import config from '../config'

export default {
  props: ['id'],
  data () {
    return {
      project: null
    }
  },
  mounted () {
    authService.getToken().then(token => {
      axios.get(
          `${config.base_url}/projects/${this.id}`,
          {headers: {'Authorization': token}}
      ).then(res => {
        this.project = res.data.projects
      })
    })
  }
}
</script>

<style scoped>
.project-detail {
  text-align: inherit;
}
#project-message {
  white-space: pre-line;
  border: 1px solid #eee;
  width: 450px;
  padding: 20px;
  text-align: initial;
}
</style>



// WEBPACK FOOTER //
// ProjectDetail.vue?767fb378